// src/features/videos/panels/ShortsPanel.tsx — right-rail Shorts entry point.
// The only way into the dedicated vertical swipe player (ShortsPlayerPage) —
// web-only, per the owner decision (right rail is web-only).
import styled from 'styled-components';
import { flashPath } from '../flashPath';
import { Link } from 'react-router-dom';
import { Panel, SectionLabel } from '@/ui';
import { VideoThumb } from '../VideoThumb';
import type { VideoItem } from '@/core/models/video';

const List = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const Row = styled(Link)`
  display: flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;
`;

const ThumbWrap = styled.div`
  position: relative;
  width: 44px;
  height: 68px;
  border-radius: ${({ theme }) => theme.radius.sm};
  overflow: hidden;
  flex-shrink: 0;
`;

const Title = styled.span`
  font-family: ${({ theme }) => theme.font.body};
  font-size: ${({ theme }) => theme.fontSize.xs};
  color: ${({ theme }) => theme.color.textPrimary};
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export interface ShortsPanelProps {
  shorts: VideoItem[];
}

export function ShortsPanel({ shorts }: ShortsPanelProps) {
  return (
    <Panel>
      <SectionLabel as="h2">Flash</SectionLabel>
      <List>
        {shorts.map((s) => (
          <li key={s.id}>
            <Row to={flashPath(s.id)} aria-label={`Play Flash: ${s.title}`}>
              <ThumbWrap>
                <VideoThumb video={s} compact />
              </ThumbWrap>
              <Title>{s.title}</Title>
            </Row>
          </li>
        ))}
      </List>
    </Panel>
  );
}
